<template>
  <form>
    <!-- Loader -->
    <div class="vgt-loading vgt-center-align" v-if="!isPageLoaded">
      <span class="vgt-loading__content">Loading...</span>
    </div>

    <div class="card">
      <div class="card-header">
        <button
          class="btn btn-default"
          v-for="lang in Object.keys(settings)"
          v-bind:key="lang"
          @click="selected = lang"
        >
          {{ lang }}
        </button>
      </div>
      <div class="card-body">
        <div
          v-for="(value, lang) in settings"
          v-bind:key="'tab' + lang"
          v-show="selected == lang"
        >
          <div class="form-group">
            <label :for="'events-id-' + lang">Contenuti in evidenza</label>
            <input
              :id="'events-id-' + lang"
              class="form-control"
              type="text"
              v-model="value.events"
            />
            <small :id="'events-id-Help-' + lang" class="form-text text-muted"
              >Lista di id da visualizzare in home</small
            >
          </div>

          <div class="form-group">
            <label :for="'events-id-' + lang">News in evidenza</label>
            <input
              :id="'events-id-' + lang"
              class="form-control"
              type="text"
              v-model="value.news"
            />
            <small :id="'events-id-Help-' + lang" class="form-text text-muted"
              >Lista di id da visualizzare in home</small
            >
          </div>

          <label>Mosaico Cultura&Castelli</label>
          <div
            v-for="(mosaico, index) in value.mosaico"
            v-bind:key="'mosaico' + index"
          >
            <p>{{ mosaico.image }}</p>

            <div class="form-group row">
              <div class="col-md-3">
                <img class="image" :src="mosaico.image" />
              </div>
              <div class="col-md-9">
                <textarea
                  rows="4"
                  :id="'mosaico-image-' + lang + index"
                  class="form-control"
                  type="text"
                  v-model="mosaico.image"
                />
                <button class="btn btn-default" @click="pickImage(mosaico)">
                  Galleria
                </button>
              </div>
            </div>

            <div class="form-group">
              <label :for="'mosaico-title-' + lang + index">Titolo</label>
              <input
                :id="'mosaico-title-' + lang + index"
                class="form-control"
                type="text"
                v-model="mosaico.title"
              />
            </div>

            <div class="form-group">
              <label :for="'mosaico-label-' + lang + index">Descrizione</label>
              <input
                :id="'mosaico-label-' + lang + index"
                class="form-control"
                type="text"
                v-model="mosaico.label"
              />
            </div>

            <div class="form-group">
              <label :for="'mosaico-url-' + lang + index">Url</label>
              <input
                :id="'mosaico-url-' + lang + index"
                class="form-control"
                type="text"
                v-model="mosaico.url"
              />
            </div>
          </div>
        </div>

        <button
          class="btn btn-success"
          v-show="!loadingPostRequest"
          v-if="isPageLoaded"
          @click="save()"
        >
          Salva
        </button>
        <button
          class="btn btn-success"
          type="button"
          disabled
          v-show="loadingPostRequest"
        >
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import axios from "axios";
import ImagePicker from "@/components/altrama/ImagePicker.vue";
import Vue from "vue";

export default {
  components: {
    ImagePicker,
  },

  data() {
    return {
      isPageLoaded: false,
      loadingPostRequest: false,

      selected: "it",
      settings: {
        it: {
          mosaico: [],
          events: "",
        },
        en: {
          mosaico: [],
          events: "",
        },
      },
    };
  },

  async created()  {
    if ( !(await this.$api.user.can("user-create") ) ) {
      this.$router.replace("/not-found");      
    }
    this.loadData();
  },

  methods: {
    loadData: function () {
      let self = this;
      axios({
        method: "get",
        url: this.$url + "operations/settings",
        headers: this.$config.axiosHeaders(),
        params: {
          section: "cultura-castelli",
        },
      })
        .then(function (response) {
          console.info(response);

          if (response.status == 200) {
            self.settings = Object.assign({}, self.settings, response.data);
          }

          self.isPageLoaded = true;
        })
        .catch(function (error) {
         self.$processError(error);
        });
    },

    pickImage(mosaicItem) {
      var ComponentClass = Vue.extend(ImagePicker);
      var instance = new ComponentClass({
        propsData: { type: "primary" },
      });
      instance.$mount();
      instance.$on("close", function () {
        instance.$destroy();
        this.$el.parentNode.removeChild(this.$el);
      });
      instance.$on("onimage", function (image) {
        mosaicItem.image = image;
        instance.$destroy();
        this.$el.parentNode.removeChild(this.$el);
      });
      this.$el.appendChild(instance.$el);
    },

    save: function () {
      let self = this;
      self.loadingPostRequest = true;

      axios({
        method: "post",
        url: this.$url + "operations/settings",
        headers: this.$config.axiosHeaders(),
        params: {
          section: "cultura-castelli",
          data: self.settings,
        },
      })
        .then(function (response) {
          console.info(response);
          self.loadingPostRequest = false;

          self.$notifyVue(
            "top",
            "center",
            "success",
            response.data.data.message,
            "ti-check"
          );
        })
        .catch(function (error) {
          self.$processError(error);
          self.loadingPostRequest = false;

          self.$notifyVue(
            "top",
            "center",
            "success",
            error.response.data.message,
            icon
          );
        });
    },
  },
};
</script>

<style scoped>
.image {
  max-height: 200px;
  width: 100%;
}
</style>